"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotesCommentsService = void 0;
class NotesCommentsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * list comments
     * @param id note uuid
     * @returns ListCommentsRes
     * @throws ApiError
     */
    listComments(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/notes/{id}/comments/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * upsert comment
     * @param id note uuid
     * @param requestBody
     * @returns SuccessIdResponse
     * @throws ApiError
     */
    upsertComment(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/notes/{id}/comments/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * delete a comment
     * @param id note uuid
     * @param commentId comment uuid
     * @returns DeleteResponse
     * @throws ApiError
     */
    deleteComment(id, commentId) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/notes/{id}/comments/{commentId}',
            path: {
                'id': id,
                'commentId': commentId,
            },
        });
    }
}
exports.NotesCommentsService = NotesCommentsService;
